import FooterInfo from '@/components/sections/Footer/FooterNav/FooterInfo'
import FooterSocials from '@/components/sections/Footer/FooterSocials'
import OrderHostingButton from '@/components/ui/OrderHostingButton'
import IFooterNavItem from '@/types/footer-nav-item.interface'

const footerNavList: { titleI18n: string; items: IFooterNavItem[]; withoutSchema?: boolean }[] = [
  {
    titleI18n: 'about-us',
    items: [
      {
        titleI18n: 'help',
        url: '/help/instructions',
      },
      {
        titleI18n: 'news',
        url: '/news',
      },
      {
        titleI18n: 'about-company',
        url: '/company/about',
      },
      {
        titleI18n: 'contacts',
        url: '/company/contacts',
      },
      {
        titleI18n: 'payment-methods',
        url: '/order/payments',
      },
      {
        titleI18n: 'documents',
        url: '/company/rules',
      },
      {
        titleI18n: 'requisites',
        url: '/company/requisites',
      },
      {
        titleI18n: 'h_promo',
        url: '/news/actions',
      },
      {
        titleI18n: 'partner',
        url: '/partner',
      },
      {
        titleI18n: 'glossary',
        url: '/glossary',
      },
      {
        titleI18n: 'invest',
        url: '/invest',
        className: '_accent',
      },
    ],
  },
  {
    titleI18n: 'services',
    items: [
      {
        titleI18n: 'hosting-services',
        url: '/',
      },
      {
        titleI18n: 'hosting-prices',
        url: '/hosting',
      },
      {
        titleI18n: 'hosting-prices-spb',
        url: '/hosting/spb',
      },
      {
        titleI18n: 'vps-vds-hosting',
        url: '/vps',
      },
      {
        titleI18n: 'domain-registration',
        url: '/domain',
      },
      {
        titleI18n: 'servers-hosting',
        url: '/arenda-servera',
      },
      {
        titleI18n: 'app-hosting',
        url: '/application',
      },
      {
        titleI18n: 'cheap-vps-hosting',
        url: '/cheap-vps',
      },
      {
        titleI18n: 'linux-hosting',
        url: '/linux-hosting',
      },
      {
        titleI18n: 'kvm-vds-hosting',
        url: '/vds-kvm-hosting',
      },
      {
        titleI18n: 'arenda-servera-spb',
        url: '/arenda-servera-v-spb',
      },
      {
        titleI18n: 'arenda-servera-msk',
        url: '/arenda-servera-v-msk',
      },
    ],
  },
  {
    titleI18n: 'additional',
    items: [
      {
        titleI18n: 'mail',
        url: '/service/mail',
      },
      {
        titleI18n: 'ssl-certificates',
        url: '/ssl',
      },
      {
        titleI18n: 'stop-spam',
        url: '/service/stopspam',
      },
      {
        titleI18n: 'constructor',
        url: '/service/constructor',
      },
      {
        titleI18n: 'website-solutions',
        url: '/articles',
      },
      {
        titleI18n: 'business-solutions',
        url: '/business',
      },
      {
        titleI18n: 'h_edu',
        url: '/hosting-dlya-uchebnykh-zavedeniy',
      },
      {
        titleI18n: 'whois-title',
        url: '/whois',
      },
      {
        titleI18n: 'move-website',
        url: '/landing',
      },
      {
        titleI18n: 'company-blog',
        url: '/news/blog',
      },
      {
        children: <OrderHostingButton />,
      },
    ],
  },
  {
    titleI18n: 'contacts',
    withoutSchema: true,
    items: [
      {
        children: <FooterInfo keyI18n="work-schedule" valueI18n="work-schedule-value" />,
      },
      {
        children: (
          <FooterInfo
            keyI18n="phone"
            values={[
              <a key="phone_4" href="tel:88007775525">
                8 (800) 777-55-25
              </a>,
              <a key="phone_1" href="tel:+78125645560">
                +7 (812) 564-55-60
              </a>,
              <a key="phone_2" href="tel:+78123353545">
                +7 (812) 335-35-45
              </a>,
              <a key="phone_3" href="tel:+74957272278">
                +7 (495) 727-22-78
              </a>,
            ]}
          />
        ),
      },
      {
        children: (
          <FooterInfo
            keyI18n="h_info"
            values={[
              <a key="h_info_1" href="mailto:info@majordomo.ru">
                info@majordomo.ru
              </a>,
            ]}
            valueAccent
          />
        ),
      },
      {
        children: (
          <FooterInfo
            keyI18n="h_sup"
            values={[
              <a key="h_support_1" href="mailto:support@majordomo.ru">
                support@majordomo.ru
              </a>,
            ]}
            valueAccent
          />
        ),
      },
      {
        children: (
          <FooterInfo
            keyI18n="h_domains"
            values={[
              <a key="h_domains_1" href="mailto:domain@majordomo.ru">
                domain@majordomo.ru
              </a>,
            ]}
            valueAccent
          />
        ),
      },
      {
        children: (
          <FooterInfo
            keyI18n="h_fin"
            values={[
              <a key="h_fin_1" href="mailto:billing@majordomo.ru">
                billing@majordomo.ru
              </a>,
            ]}
            valueAccent
          />
        ),
      },
      {
        children: (
          <FooterInfo keyI18n="h_soc">
            <FooterSocials />
          </FooterInfo>
        ),
      },
    ],
  },
]

export default footerNavList
